import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { BuyersSize } from "../buyers-destination/buyers-sizes.entity";
import { StocktransferEntity } from "./stock-transfer-entity";

@Entity('stock_items_transfer')
export class StockItemstransferEntity{
  
    @PrimaryGeneratedColumn("increment",{name:'id'})
id:number;

@Column("varchar",{
    nullable: true,
    length:20,
    name:"item_type"
})
itemType:string;


@Column("int",{
    nullable: true,
    name:"item_id"
})
itemId:number;

@Column("int",{
    nullable: false,
    name:"stock_id"
})
stockId:number;


@Column("int",{
    nullable: false,
    name:"received_stock_id"
})
receivedStockId:number;

@Column("int",{
    nullable: true,
    name:"buyer_id"
})
buyerId:number;

@Column("int",{
    nullable: true,
    name:"excel_no"
})
excelNo:number;

@Column("int",{
    nullable: true,
    name:"loaction"
})
loaction:number;

@Column("int",{
    nullable: true,
    name:"rack_id"
})
rackId:number;

@Column("int",{
    nullable: true,
    name:"quantity"
})
quantity:number;

@Column("int",{
    nullable: true,
    name:"sts"
})
sts:number;

@Column("int",{
    nullable: true,
    name:"dc_qty"
})
dcQty:number;

@Column("int",{
    nullable: true,
    name:"allocated_qty"
})
allocatedQty:number;

@Column("int",{
    nullable: true,
    name:"uom_id"
})
uomId:number;

@Column("varchar",{
    nullable: true,
    length:20,
    name:"remarks"
})
remarks:string;

@Column("int",{
    nullable: true,
    name:"negative_stock"
})
negativeStock:number;

@Column("boolean",{
    default:true,
    name:"is_active"
    })
  isActive:boolean;

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "created_user"
})
createdUser: string | null;

@UpdateDateColumn({
    name: "updated_at",
    type:'datetime'
})
updatedAt: Date;

@Column("varchar", {
    nullable: true,
    name: "updated_user"
})
updatedUser: string | null;

@VersionColumn({
    default:1,
    name: "version_flag"
})
versionFlag: number;


@OneToOne(type => StocktransferEntity, stock => stock.itemInfo)
@JoinColumn({ name: 'stock_transfer_id' })
stockInfo: StocktransferEntity

}
